import React from 'react';
import Body from '../components/Body';

const HomePage = () => {
  return <Body />;
};

export default HomePage;
